module.exports = __webpack_public_path__ + "media/Spring's story.879cf161.mp3";